import { createFileRoute } from '@tanstack/react-router'
import WhiteBoard from '@/components/WhiteBoard/WhiteBoard'
import { guardWhiteboard } from '../lib/auth/routeGuards'

export const Route = createFileRoute('/whiteboard')({
  beforeLoad: guardWhiteboard,
  component: RouteComponent,
})

function RouteComponent() {
  return <WhiteBoard />
}
